import type {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';
import type {ProgressDb} from './progressDbSchema';
import {ProgressWrite, progressWriteSchema} from './progressWriteSchema';

/**
 * Map a write shape to ProgressDb, filling timestamp fields.
 * Intended for creating or replacing a progress document.
 */
export function mapProgressWriteToDb(write: ProgressWrite, timestamp: FirestoreTimestamp): ProgressDb {
  return {
    ...progressWriteSchema.parse(write),
    lastUpdated: timestamp,
  };
}
